import { render, staticRenderFns } from "./thought_report.vue?vue&type=template&id=3a5b165a&scoped=true"
import script from "./thought_report.vue?vue&type=script&lang=js"
export * from "./thought_report.vue?vue&type=script&lang=js"
import style0 from "./thought_report.vue?vue&type=style&index=0&id=3a5b165a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5b165a",
  null
  
)

export default component.exports